import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
    Checkbox,
    styled,
    FormControl,
    InputLabel,
    Select,
    Chip,
    MenuItem,
    ListItemText,
    FormHelperText,
    OutlinedInput,
} from '@mui/material';

import {
    LoadingButton
} from '@mui/lab';

// import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { useLocations, locationTypes, targetTypes } from "../../../hooks/api/useLocations";
import { useUsers, userTypes, targetTypes as targetWorker } from '../../../hooks/api/useUsers';
import { useAppContextFeatures } from '../../../context/AppContext';

import { spliceString } from "../../../utils/formatString"
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { initialValues, validationSchema } from "../../../schema/locations/zoneSchema";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useTranslations } from "../../../hooks/useTranslations";

const StyledCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function UpdateZone({
    id,
    parentId,
    handleOnSuccess
}) {
    const { t } = useTranslations({ ns: ["common", "@location"] })

    const { promptMessage } = useSystemPrompt();
    const { isLoading, update, get, list: listRack } = useLocations({ locationType: locationTypes.zone, targetType: targetTypes.zone });
    const { list: listWorker } = useUsers({ userType: userTypes.worker });

    const { setSystemLoading } = useAppContextFeatures();
    const [savedValues, setSavedValues] = useState()
    const [dataRacks, setDataRacks] = useState([])
    const [dataWorkers, setDataWorkers] = useState([])

    const loadData = async (id) => {

        setSystemLoading(true)

        try {

            // const { data } = await get({ id })
            // const { zone } = data;

            const { data } = await get({ id, dataTypesArray: ["rack", "worker", "rack_item", "worker_item"] })

            const { zone } = data
            const {
                workers: allWorkers = [],
                racks: allRacks = []
            } = zone

            let rackId = allRacks.length ? allRacks.map(i => i.rack_id) : []
            let workerId = allWorkers.length ? allWorkers.map(i => i.user_id) : []

            // console.log('workerId', workerId, allWorkers)

            setSavedValues({
                locationId: parentId,
                zoneName: zone?.zone_name,
                zoneCode: zone?.zone_code,
                sequence: zone?.zone_sequence ? zone.zone_sequence : "",
                status: zone?.status === '1',
                defaultStatus: zone?.is_default === '1',
                // rackId: zone?.rack_Id,
                // workerId: zone?.user_Id
                rackId,
                workerId
            })

            // console.log("Zone", data)


        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            const workers = currentValues.workerId.map((i) => {
                return {
                    zone_item_id: "",
                    user_id: i
                }
            })

            const racks = currentValues.rackId.map((i) => {
                return {
                    zone_item_id: "",
                    rack_id: i
                }
            })

            let data = {
                zone: {
                    zone_name: currentValues?.zoneName,
                    zone_code: currentValues?.zoneCode,
                    sequence: currentValues?.sequence,
                    is_default: currentValues?.defaultStatus ? 1 : 0,
                    status: currentValues?.status ? 1 : 0,
                },
                racks,
                workers
            }

            const response = await update({ id, data });

            promptMessage(true, `${response?.message}`)

            if (handleOnSuccess) handleOnSuccess()

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)
    }

    const fetchRackData = async (props) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [],
                sortInfo: {
                    id: "rack_name",
                    dir: 0,
                }
            }

            props.locationType = locationTypes.rack
            props.parentId = parentId

            const { data } = await listRack(props)

            setDataRacks(data?.racks)

        } catch (error) {
            promptMessage(false, `Error getting results (${error?.message})`)
        }
    }

    const fetchWorkerData = async (props) => {

        try {

            const props = {
                limit: -1,
                skip: 0,
                filterValue: [],
                sortInfo: {
                    id: "username",
                    dir: 0,
                }
            }

            props.userType = userTypes.worker

            const { data } = await listWorker(props)

            setDataWorkers(data?.workers)

        } catch (error) {
            promptMessage(false, `Error getting results (${error?.message})`)
        }
    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    useEffect(() => {

        loadData(id)
        fetchRackData()
        fetchWorkerData()

    }, [])

    const getRackOptionNameByIds = (optionIdArray) => {

        if (!optionIdArray) return []

        dataRacks.filter(i => i.rackId === parentId)

        let optionNames = [];

        dataRacks.forEach((e) => {
            // e.options.forEach((e2) => {
            // if(e2.option_key === optionIdArray){
            if (optionIdArray.includes(e.id)) {
                optionNames.push(e.rack_name)
            }
            // })
        })

        return optionNames
    }

    const getWorkerOptionNameByIds = (optionIdArray) => {

        if (!optionIdArray) return []

        dataWorkers.filter(i => i.workerId === parentId)

        let optionNames = [];

        dataWorkers.forEach((e) => {
            // e.options.forEach((e2) => {
            // if(e2.option_key === optionIdArray){
            if (optionIdArray.includes(e.user_id)) {
                optionNames.push(e.username)
            }
            // })
        })

        return optionNames
    }

    const RenderForm = () => {

        if (!values) return <></>

        return (

            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0.5}>

                        <Grid item xs={12} sm={12} md={12}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={6} sm={6} md={4}>
                                    <FormControlLabel
                                        sx={{
                                            marginLeft: '1px'
                                        }}
                                        control={
                                            <Switch
                                                name="status"
                                                checked={Boolean(values?.status)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("status", checked);
                                                }}
                                            />
                                        }
                                        label={
                                            Boolean(values.status) ? t("enabled") : t("disabled")
                                        }
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6} md={8}>
                                    <></>
                                </Grid>
                                {/* <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="defaultStatus" 
                                                checked={Boolean(values.defaultStatus)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("defaultStatus", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.defaultStatus)? "Default" : "Not Default"
                                        }
                                    />
                                </Grid> */}

                                <Grid item xs={12} sm={12} md={8}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"zoneName"}
                                        label={t("zoneName")}
                                        type="text"
                                        variant="outlined"
                                        value={values.zoneName}
                                        onChange={handleChange}
                                        error={touched.zoneName && Boolean(errors.zoneName)}
                                        helperText={touched.zoneName && errors.zoneName}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={6} md={2}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name={"zoneCode"}
                                        label={t("zoneCode")}
                                        type="text"
                                        variant="outlined"
                                        value={values.zoneCode}
                                        onChange={handleChange}
                                        error={touched.zoneCode && Boolean(errors.zoneCode)}
                                        helperText={touched.zoneCode && errors.zoneCode}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={6} md={2}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name={"sequence"}
                                        label={t("sortNo")}
                                        type="text"
                                        variant="outlined"
                                        value={values.sequence}
                                        onChange={handleChange}
                                        error={touched.sequence && Boolean(errors.sequence)}
                                        helperText={touched.sequence && errors.sequence}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={touched.rackId && Boolean(errors.rackId)}
                                    >
                                        <InputLabel id="rack">{t("rack")}</InputLabel>

                                        <Select
                                            labelId="rackId"
                                            label={t("rack")}
                                            name={"rackId"}
                                            onChange={(event) => {
                                                setFieldValue("rackId", event.target.value)
                                            }}
                                            value={values.rackId.length ? values.rackId : []}
                                            renderValue={(selected) => {

                                                return (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {
                                                            getRackOptionNameByIds(selected).map((i, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    // color={'red'}
                                                                    label={spliceString({ val: i, maxLength: 20 })}
                                                                />
                                                            ))
                                                        }
                                                    </Box>
                                                )

                                            }}
                                            multiple
                                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                        >
                                            {
                                                dataRacks?.map((i, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={i?.id}
                                                        >
                                                            <Checkbox checked={values.rackId.indexOf(i?.id) > -1} />
                                                            <ListItemText
                                                                primary={`${i.rack_name}`}
                                                            />
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </Select>
                                        <FormHelperText>
                                            {touched.rackId && errors.rackId}
                                        </FormHelperText>

                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>

                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={touched.workerId && Boolean(errors.workerId)}
                                    >
                                        <InputLabel id="worker">{t('worker')}</InputLabel>

                                        <Select
                                            labelId="workerId"
                                            label={t("worker")}
                                            name={"workerId"}
                                            onChange={(event) => {
                                                setFieldValue("workerId", event.target.value)
                                            }}
                                            value={values.workerId.length ? values.workerId : []}
                                            renderValue={(selected) => {

                                                return (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                        {
                                                            getWorkerOptionNameByIds(selected).map((i, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    // color={'red'}
                                                                    label={spliceString({ val: i, maxLength: 20 })}
                                                                />
                                                            ))
                                                        }
                                                    </Box>
                                                )

                                            }}
                                            multiple
                                            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                        >
                                            {
                                                dataWorkers?.map((i, index) => {
                                                    return (
                                                        <MenuItem
                                                            key={index}
                                                            value={i?.user_id}
                                                        >
                                                            <Checkbox checked={values.workerId.indexOf(i?.user_id) > -1} />
                                                            <ListItemText
                                                                primary={`${i.username}`}
                                                            />
                                                        </MenuItem>
                                                    )
                                                })
                                            }

                                        </Select>
                                        <FormHelperText>
                                            {touched.workerId && errors.workerId}
                                        </FormHelperText>

                                    </FormControl>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </StyledCard>

                <Box
                    sx={{
                        mx: 2,
                        mr: 2
                    }}
                >
                    <LoadingButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        loading={isLoading}
                    >
                        {t('saveChanges')}
                    </LoadingButton>
                </Box>
            </form>
        )
    }

    return (

        <Box>

            {RenderForm()}

        </Box>
    )
}